import Modal, { ModalRef } from '@ui-components-3/ui/lib/components/Modal'
import { forwardRef } from 'react'

type ConfirmEndPhoneCallModalProps = {
  onConfirm: () => void
}

const ConfirmEndPhoneCallModal = forwardRef<ModalRef, ConfirmEndPhoneCallModalProps>(({ onConfirm }, ref) => {
  return (
    <Modal
      ref={ref}
      label="Confirm End Phone Call"
      footer={({ close }) => (
        <>
          <button onClick={close} className="btn btn-neutral-borderless">
            No
          </button>
          <button
            onClick={() => {
              close()
              onConfirm()
            }}
            className="btn btn-fuchsia-outlined"
          >
            Yes
          </button>
        </>
      )}
    >
      <p className="text-neutral-800 typography-body-l">Are you sure you want to end this phone call?</p>
    </Modal>
  )
})

export default ConfirmEndPhoneCallModal
